{
  "en": {
    "documentFilters": {
      "phase": {
        "PC": "PC",
        "AT": "AT",
        "APD": "APD",
        "APS": "APS",
        "PRO": "PRO",
        "DCE": "DCE",
        "MARCHE": "MARCHE",
        "EXE": "EXE",
        "DOE": "DOE",
        "ADMIN SOCOTEC": "Admin SOCOTEC"
      },
      "type": {
        "PLAN": "Plan",
        "NDC": "Calculation Note",
        "FTP": "Technical Product Sheet",
        "AUTO": "Self-inspection",
        "PV": "Verbal Process",
        "TH": "Thermal and Environmental Study",
        "GEO": "Geotechnical Study",
        "PH": "Acoustic Study",
        "DPE": "DPE",
        "ATH_ATM": "Documents for Thermal Certificate",
        "APH_ATM": "Documents for Acoustic Certificate",
        "MAIL": "Mail",
        "CCTP": "CCTP",
        "DIAG": "Diagnosis",
        "NOTICE": "Safety & Accessibility Notice",
        "AVIS": "Commission Opinion (PC, AT…)",
        "ARRETE": "Permit Decree",
        "PHOTO": "Photo",
        "CONTRAT": "Contract",
        "DEVIS": "Quote",
        "REVUE_DE_CONTRAT": "Contract Review",
        "AVENANT": "Amendment",
        "REP": "Review Response",
        "CR": "Site Meeting Report"
      },
      "origin": {
        "BIMDATA_GED": "BIMData GED",
        "SEDI": "SEDI",
        "MANUAL": "Manual"
      },
      "topic": {
        "POSITIVE": "Favorable",
        "NEGATIVE": "Unfavorable",
        "SUSPENDED": "Suspended",
        "OUT_OF_SCOPE": "Out of scope",
        "FOR_MEMORY": "For memory",
        "NOTHING_TO_REPORT": "Nothing to report"
      }
    }
  },
  "fr": {
    "documentFilters": {
      "phase": {
        "PC": "PC",
        "AT": "AT",
        "APD": "APD",
        "APS": "APS",
        "PRO": "PRO",
        "DCE": "DCE",
        "MARCHE": "MARCHE",
        "EXE": "EXE",
        "DOE": "DOE",
        "ADMIN SOCOTEC": "Admin SOCOTEC"
      },
      "type": {
        "PLAN": "Plan",
        "NDC": "Note de calcul",
        "FTP": "Fiche technique produit",
        "AUTO": "Autocontrôle",
        "PV": "Procès Verbal",
        "TH": "Étude thermique et environnementale",
        "GEO": "Étude géotechnique",
        "PH": "Étude acoustique",
        "DPE": "DPE",
        "ATH_ATM": "Documents pour attestation thermique",
        "APH_ATM": "Documents pour attestation acoustique",
        "MAIL": "Courrier",
        "CCTP": "CCTP",
        "DIAG": "Diagnostic",
        "NOTICE": "Notice de sécurité & accessibilité",
        "AVIS": "Avis de commission (PC, AT…)",
        "ARRETE": "Arrêté de permis",
        "PHOTO": "Photo",
        "CONTRAT": "Contrat",
        "DEVIS": "Devis",
        "REVUE_DE_CONTRAT": "Revue de contrat",
        "AVENANT": "Avenant",
        "REP": "Réponse Avis",
        "CR": "Compte Rendu de réunion de chantier"
      },
      "origin": {
        "BIMDATA_GED": "BIMData GED",
        "SEDI": "SEDI",
        "MANUAL": "Manuel"
      },
      "topic": {
        "POSITIVE": "Favorable",
        "NEGATIVE": "Défavorable",
        "SUSPENDED": "Réserve",
        "OUT_OF_SCOPE": "Hors champ",
        "FOR_MEMORY": "Pour mémoire",
        "NOTHING_TO_REPORT": "Rien à signaler"
      }
    }
  },
  "nl": {
    "documentFilters": {
      "phase": {
        "PC": "PC",
        "AT": "AT",
        "APD": "APD",
        "APS": "APS",
        "PRO": "PRO",
        "DCE": "DCE",
        "MARCHE": "MARCHE",
        "EXE": "EXE",
        "DOE": "DOE",
        "ADMIN SOCOTEC": "Admin SOCOTEC"
      },
      "type": {
        "PLAN": "Plan",
        "NDC": "Berekeningsnotitie",
        "FTP": "Technisch productgegevensblad",
        "AUTO": "Zelfcontrole",
        "PV": "Mondelinge verslaglegging",
        "TH": "Thermische en milieustudie",
        "GEO": "Geotechnische studie",
        "PH": "Akoestische studie",
        "DPE": "DPE",
        "ATH_ATM": "Documenten voor warmtecertificaat",
        "APH_ATM": "Documenten voor akoestisch certificaat",
        "MAIL": "Post",
        "CCTP": "CCTP",
        "DIAG": "Diagnose",
        "NOTICE": "Veiligheids- en toegankelijkheidskennisgeving",
        "AVIS": "Commissiemening (PC, AT…)",
        "ARRETE": "Vergunningsbesluit",
        "PHOTO": "Foto",
        "CONTRAT": "Contract",
        "DEVIS": "Offerte",
        "REVUE_DE_CONTRAT": "Contractbeoordeling",
        "AVENANT": "Wijziging",
        "REP": "Antwoord op advies",
        "CR": "Verslag bouwvergadering"
      },
      "origin": {
        "BIMDATA_GED": "BIMData GED",
        "SEDI": "SEDI",
        "MANUAL": "Handmatig"
      },
      "topic": {
        "POSITIVE": "Gunstig",
        "NEGATIVE": "Ongunstig",
        "SUSPENDED": "Opgeschort",
        "OUT_OF_SCOPE": "Buiten bereik",
        "FOR_MEMORY": "Voor geheugen",
        "NOTHING_TO_REPORT": "Niets te melden"
      }
    }
  }
}
